import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import { mockServices } from '../data/mock';

const Services = () => {
  const navigate = useNavigate();

  const detailedServices = [
    {
      ...mockServices[0],
      details: [
        'Business cards & stationery',
        'Brochures & catalogs',
        'Large format printing',
        'Packaging design'
      ]
    },
    {
      ...mockServices[1],
      details: [
        'Custom vehicle wraps',
        'Fleet branding',
        '3D mockups & visualization',
        'Installation coordination'
      ]
    },
    {
      ...mockServices[2],
      details: [
        'Office & retail spaces',
        'Event backdrops',
        'Building wraps',
        'Interior graphics'
      ]
    },
    {
      ...mockServices[3],
      details: [
        'Responsive web design',
        'WordPress development',
        'E-commerce platforms',
        'Web applications'
      ]
    },
    {
      ...mockServices[4],
      details: [
        'Video production',
        'Audio editing & mixing',
        'Motion graphics',
        'Post-production'
      ]
    },
    {
      ...mockServices[5],
      details: [
        'Event branding',
        'Stage design',
        'Signage & wayfinding',
        'Promotional materials'
      ]
    },
    {
      ...mockServices[6],
      details: [
        'Process diagnosis & optimization',
        'Production structure design',
        'Operational efficiency planning',
        'Methodology implementation'
      ]
    }
  ];

  return (
    <div className="bg-black text-white pt-24">
      {/* Hero */}
      <section className="py-24 bg-gradient-to-br from-black to-gray-900">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Our <span className="text-[#F4B400]">Services</span>
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Comprehensive creative and consulting solutions to transform your business
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-white text-black">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {detailedServices.map((service) => {
              const IconComponent = require('lucide-react')[service.icon];
              return (
                <Card 
                  key={service.id}
                  className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-[#F4B400]"
                >
                  <CardContent className="p-8">
                    <div className="bg-[#F4B400] w-16 h-16 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className="text-black" size={32} />
                    </div>
                    <h3 className="text-2xl font-bold mb-3">{service.title}</h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                    <ul className="space-y-2">
                      {service.details.map((detail, index) => (
                        <li key={index} className="flex items-start">
                          <span className="text-[#F4B400] mr-2">•</span>
                          <span className="text-gray-700">{detail}</span>
                        </li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Corporate Consulting Highlight */}
      <section className="py-24 bg-black">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold mb-8 text-center">Corporate Consulting</h2>
            <p className="text-xl text-gray-300 mb-12 leading-relaxed text-center">
              Specialized business administration consulting focused on production-based company structuring, 
              process optimization, internal organization, and operational efficiency.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Card className="bg-white text-black">
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-[#F4B400]">Our Approach</h3>
                  <p className="text-gray-700 leading-relaxed">
                    We analyze your current operations, identify inefficiencies, and design customized solutions 
                    that align with your production goals and business objectives.
                  </p>
                </CardContent>
              </Card>
              <Card className="bg-white text-black">
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-[#F4B400]">Methodology</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Implementation of objective-based methodologies, role structuring, performance metrics, 
                    and continuous improvement frameworks tailored to your industry.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-white text-black">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">Ready to Get Started?</h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Let's discuss how our services can help elevate your brand and optimize your operations.
            </p>
            <Button
              onClick={() => navigate('/contact')}
              size="lg"
              className="bg-[#F4B400] text-black hover:bg-[#d49f00] text-lg px-8 py-6"
            >
              Contact Us
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;